var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferredCheckboxIcon = function SvgTransferredCheckboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 6,
    y: 6,
    fill: "#19AF00",
    stroke: "#19AF00",
    strokeWidth: 1.5,
    opacity: 0.5,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#131B20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12 9 3 3-3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#131B20",
    d: "M9 11.25a.75.75 0 0 0 0 1.5zm6 0H9v1.5h6z"
  })));
};
export { SvgTransferredCheckboxIcon as ReactComponent };
export default __webpack_public_path__ + "9d5c57fcd5aac2812f712e84a1961c49.svg";